import constate from "constate";
import { type TBreakpointState as TBpState, useBreakpoint } from "hooks/useBreakpoint";
import { useMemo } from "react";
import { Bp } from "utils/ui/breakpoints";

export type TBreakpointsState = {
  state: {
    currentBp: Bp;
    EIGHTY: TBreakpointState;
    FIFTY: TBreakpointState;
    FORTY: TBreakpointState;
    SEVENTY: TBreakpointState;
    SIXTY: TBreakpointState;
    TEN: TBreakpointState;
    THIRTY: TBreakpointState;
    TWENTY: TBreakpointState;
  };
};
export type TBreakpointState = TBpState;

const useBreakpoints = (): TBreakpointsState => {
  const TEN = useBreakpoint(Bp.TEN);
  const TWENTY = useBreakpoint(Bp.TWENTY);
  const THIRTY = useBreakpoint(Bp.THIRTY);
  const FORTY = useBreakpoint(Bp.FORTY);
  const FIFTY = useBreakpoint(Bp.FIFTY);
  const SIXTY = useBreakpoint(Bp.SIXTY);
  const SEVENTY = useBreakpoint(Bp.SEVENTY);
  const EIGHTY = useBreakpoint(Bp.EIGHTY);

  const currentBp = useMemo(() => {
    // The order matters
    const isExact = [EIGHTY, SEVENTY, SIXTY, FIFTY, FORTY, THIRTY, TWENTY, TEN].find((bp) => bp.isExact)!;
    return isExact?.breakingPoint || Bp.TEN;
  }, [TEN, TWENTY, THIRTY, FORTY, FIFTY, SIXTY, SEVENTY, EIGHTY]);

  return { state: { currentBp, EIGHTY, FIFTY, FORTY, SEVENTY, SIXTY, TEN, THIRTY, TWENTY } };
};

export const [BreakpointsProvider, useBreakpointsContext] = constate(useBreakpoints);
